import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import type { SearchResult } from '@/queries/listingSearchQuery'

/**
 * Exported so a surface can restyle the line to its own scale with a nested
 * selector (the way BetterOddsStrip restyles TimeLeftRowContainer) instead
 * of wrapping it.
 */
export const BidderCountContainer = styled.span``

/**
 * The odds signal for a Better Odds candidate, framed as the buyer's
 * advantage ("Only 2 bidders"). Shared by the My Bids strip and the homepage
 * carousel so both surfaces always say the same thing. An unbid 3MP auction
 * reports zero; a missing count is unknown, not zero, so callers skip those
 * listings, as `computeGap` does.
 */
export const BetterOddsBidderCount = ({
  listing,
}: {
  listing: SearchResult
}) => (
  <BidderCountContainer data-testid="unique-bidders">
    <FormattedMessage
      id="Common.BetterOdds.uniqueBidders"
      values={{ bidders: listing.auction3MP?.uniqueBidders ?? 0 }}
    />
  </BidderCountContainer>
)
